import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bookmark, Columns3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { PageHeader, EmptyState } from "@/components/Common";
import { CandidateCard } from "@/components/CandidateCard";
import { useFetch, useShortlist } from "@/lib/api";

export default function Shortlist() {
  const { data } = useFetch("/shortlist");
  const { ids, toggle } = useShortlist();
  const [sel, setSel] = useState([]);
  const nav = useNavigate();
  const list = (data || []).filter((c) => ids.includes(c.id));
  const pick = (id, v) => setSel(v ? [...sel, id].slice(-3) : sel.filter((x) => x !== id));

  return (
    <div>
      <PageHeader eyebrow="Your picks" title="Shortlist" desc="Tick up to 3 candidates to compare side by side.">
        <Button data-testid="compare-button" disabled={sel.length < 2} onClick={() => nav(`/app/compare?ids=${sel.join(",")}`)}><Columns3 className="mr-2 h-4 w-4" />Compare ({sel.length})</Button>
      </PageHeader>
      {data && list.length === 0 ? (
        <EmptyState testId="shortlist-empty" icon={Bookmark} title="Your shortlist is empty" desc="Tap the bookmark on any candidate to save them here.">
          <Link to="/app/candidates" className="rounded-md bg-slate-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-slate-700">Browse candidates</Link>
        </EmptyState>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {list.map((c) => (
            <div key={c.id} className="relative">
              <label className="absolute -top-3 left-4 z-10 flex items-center gap-2 rounded-full border border-stone-200 bg-white px-3 py-1 text-xs shadow-sm">
                <Checkbox data-testid={`compare-select-${c.id}`} checked={sel.includes(c.id)} onCheckedChange={(v) => pick(c.id, v)} />Compare
              </label>
              <CandidateCard c={c} shortlisted onToggle={toggle} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
